import React, { createContext, useContext, useState } from 'react';
import { ethers } from 'ethers';

const Web3Context = createContext();

export const useWeb3Context = () => useContext(Web3Context);

export const Web3Provider = ({ children }) => {
    const [globalProvider, setProvider] = useState(null);

    const [refresh, setRefresh] = useState(false);

    const refreshPage = () => {
        setRefresh(!refresh);
    }

    const connectWallet = async () => {
        try {
            if (window.ethereum) {
                await window.ethereum.request({ method: 'eth_requestAccounts' });
                const newProvider = new ethers.BrowserProvider(window.ethereum);
                setProvider(newProvider);
            } else {
                alert('Please install a Web3-enabled browser like MetaMask');
            }
        } catch (error) {
            console.error('Error connecting wallet:', error);
            alert('Failed to connect wallet. Please try again.');
        }
    };

    return (
        <Web3Context.Provider value={{ globalProvider, connectWallet,refresh,refreshPage }}>
            {children}
        </Web3Context.Provider>
    );
};